import { createTheme } from "@mui/material/styles";
import { Palette } from "@mui/material";

declare module "@mui/material/styles/createPalette" {
  interface TypeBackground {
    variant?: string;
  }
}

export const paletteStandard: Palette = createTheme({
  palette: {
    primary: {
      main: "#000000",
      light: "#E2E2E2",
      dark: "#2E3032",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#A3E0FC",
      light: "#F4FBFF",
      dark: "#006783",
      contrastText: "#003545",
    },
    tertiary: {
      main: "#37EFDE",
      light: "#B3FFF3",
      dark: "#00C0B0",
      contrastText: "#003732",
    },
    text: {
      primary: "#000000",
      secondary: "#41484D",
      disabled: "#9BA4AB",
    },
    header: {
      main: "#000000",
      contrastText: "#FFFFFF",
    },
    outline: "#70787D",
    divider: "#C0C7CD",
    background: {
      default: "#F8F9FB",
      paper: "#FFFFFF",
      variant: "#E9EAEC",
    },
    accent: {
      main: "#93A6FF",
      light: "#EFEFFF",
      dark: "#314AAA",
      contrastText: "#001354",
    },
    error: {
      main: "#C00000",
      light: "#FF8A78",
      dark: "#930000",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#1E81A1",
      light: "#A3E0FC",
      dark: "#004D63",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#00C64D",
      light: "#4BB763",
      dark: "#005A14",
      contrastText: "#000000",
    },
    warning: {
      main: "#FDD422",
      light: "#FFF0C6",
      dark: "#8E7500",
      contrastText: "#000000",
    },
  },
}).palette;
